import z from "zod";

const val3dityErrorTypeValues = ["VAL3DITY_TIMED_OUT", "VAL3DITY_NO_REPORT"] as const;

const val3dityErrorTypeSchema = z.enum(val3dityErrorTypeValues);
const Val3dityErrorType = val3dityErrorTypeSchema.enum;
type Val3dityErrorType = z.infer<typeof val3dityErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type Val3dityErrors =
  | {
      errorType: typeof Val3dityErrorType.VAL3DITY_TIMED_OUT;
      data: {
        timeoutMs: number;
      };
    }
  | {
      errorType: typeof Val3dityErrorType.VAL3DITY_NO_REPORT;
      data: {
        exitCode: number | null;
        stderr: string;
      };
    };

export const val3dityErrorDetails: Record<Val3dityErrorType, ErrorDetails> = {
  [Val3dityErrorType.VAL3DITY_TIMED_OUT]: {
    sentryDescription: "val3dity did not finish before its timeout",
  },
  [Val3dityErrorType.VAL3DITY_NO_REPORT]: {
    sentryDescription: "val3dity exited without writing a report",
  },
};
